import Diversity3Icon from '@mui/icons-material/Diversity3';
import PsychologyIcon from '@mui/icons-material/Psychology';
import SchoolIcon from '@mui/icons-material/School';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import CenterFocusStrongIcon from '@mui/icons-material/CenterFocusStrong';
import HistoryToggleOffIcon from '@mui/icons-material/HistoryToggleOff';

export const Locations = [
    {
        title: 'Scottsdale',
        url: 'https://icodeschool.com/scottsdale',
        phone: '480.809.9429',
        address1: '13910 N Frank Lloyd Wright Blvd. #100',
        address2: 'Scottsdale, AZ 85260',
        email: 'scottsdale@icodeschool.com',
        map: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3322.7536838820597!2d-111.86763472458716!3d33.6116949408645!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x872b75219ea6f26b%3A0xc7faa2b3cf5d0466!2siCode%20Scottsdale!5e0!3m2!1sen!2sus!4v1702568018365!5m2!1sen!2sus" height="300" width="100%" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
        fb: '',
        ig: ''
    },
    {
        title: 'Chandler',
        url: 'https://icodeschool.com/chandler',
        phone: '480.222.8991',
        address1: '1960 W. Germann Rd. #2&3',
        address2: 'Chandler, AZ 85286',
        email: 'chandler@icodeschool.com',
        map: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3335.572673811636!2d-111.87782272460065!3d33.277677958232566!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x872b0123d25fd1df%3A0xe18af195ab4d7102!2siCode%20Chandler!5e0!3m2!1sen!2sus!4v1702568039789!5m2!1sen!2sus" height="300" width="100%" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
        fb: '',
        ig: ''
    },
    {
        title: 'Peoria',
        url: 'https://icodeschool.com/peoria-az',
        phone: '623.250.5030',
        address1: '9127 West Union Hills Drive #301',
        address2: 'Peoria, AZ 85382',
        email: 'peoria@icodeschool.com',
        map: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3321.1930764694357!2d-112.2581390245855!3d33.652158738750465!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x872b43b7fc049c99%3A0x7128418c60d6b7fd!2siCode%20Peoria!5e0!3m2!1sen!2sus!4v1702567959770!5m2!1sen!2sus" height="300" width="100%" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
        fb: '',
        ig: ''
    }
]

export const IsportInfo = [
    {
        Icon: <Diversity3Icon/>,
        primaryText: 'Teamwork and Communication Skills',
        secondaryText: 'Effective collaboration with teammates is essential for success in many eSports, fostering a sense of camaraderie and shared goals.'
    },
    {
        Icon: <PsychologyIcon/>,
        primaryText: 'Critical Thinking and Problem-Solving',
        secondaryText: 'Many eSports games require quick thinking, strategic planning, and adaptability.'
    },
    {
        Icon: <SchoolIcon/>,
        primaryText: 'Scholarship Opportunities',
        secondaryText: 'As eSports gain recognition, many colleges and universities are offering scholarships for talented players. Involvement in eSports could open doors to educational opportunities for your child.'
    },
    {
        Icon: <TrackChangesIcon/>,
        primaryText: 'Hand-Eye Coordination',
        secondaryText: 'This can have positive implications in other areas of life, such as academics or sports that require manual dexterity.'
    },
    {
        Icon: <CenterFocusStrongIcon/>,
        primaryText: 'Focus and Concentration',
        secondaryText: 'This can translate into improved attention spans and discipline, as players need to stay engaged for extended periods to perform at their best.'
    },
    {
        Icon: <HistoryToggleOffIcon/>,
        primaryText: 'Self-discipline',
        secondaryText: 'eSports instills a sense of self-discipline and time management at a young age, teaching the importance of setting goals and working consistently to achieve them.'
    },
]